import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

export function Loader({ className }: { className?: string }) {
  return <Loader2 className={cn('h-5 w-5 animate-spin text-muted-foreground', className)} />;
}

export function FullPageLoader() {
  return <div className="min-h-screen flex items-center justify-center bg-background"><Loader className="h-8 w-8" /></div>;
}
